
/** @param {ParentNode} wrap @returns {HTMLVideoElement | null} */
function getVideoInWrap(wrap) {
  return wrap.querySelector("video-background-component video");
}

/** @param {Element | null} el @param {boolean} hidden */
function toggleHidden(el, hidden) {
  if (!el) return;
  el.classList.toggle("hidden", hidden);
}

/** @param {ParentNode} wrap @param {boolean} isPaused */
function syncButtons(wrap, isPaused) {
  const btn = wrap.querySelector(".vp-review-card__play-btn");
  const pauseBtn = wrap.querySelector(".vp-review-card__pause-btn");
  toggleHidden(btn, !isPaused);
  toggleHidden(pauseBtn, isPaused);
}

/** @param {HTMLElement} wrap */
function bindMediaWrap(wrap) {
  const video = getVideoInWrap(wrap);
  if (!video) return;
  if (wrap.dataset.vpReviewCardVideoBound === "true") return;
  wrap.dataset.vpReviewCardVideoBound = "true";

  // Force consistent initial UX: start paused until user clicks play.
  video.pause();

  const sync = () => syncButtons(wrap, video.paused);

  video.addEventListener("playing", sync);
  video.addEventListener("pause", sync);
  video.addEventListener("ended", sync);
  sync();
}

function initVpReviewCardVideos() {
  document.querySelectorAll(".vp-review-card__media-wrap").forEach(bindMediaWrap);
}

document.addEventListener("click", (e) => {
  if (!(e.target instanceof Element)) return;

  const actionBtn = e.target.closest(".vp-review-card__play-btn, .vp-review-card__pause-btn");
  if (!actionBtn) return;

  const wrap = actionBtn.closest(".vp-review-card__media-wrap");
  if (!wrap) return;

  const video = getVideoInWrap(wrap);
  if (!video) return;

  e.preventDefault();
  e.stopPropagation();

  if (actionBtn.classList.contains("vp-review-card__pause-btn")) {
    video.pause();
    return;
  }

  video.play().catch(() => {});
});

document.addEventListener("DOMContentLoaded", initVpReviewCardVideos);
document.addEventListener("shopify:section:load", initVpReviewCardVideos);
